import { ButtonOutline } from 'remote-com-shared/components/Button';
import MenuEntry from 'remote-com-shared/components/HeaderNavigation/MenuEntry';
import MenuItem from 'remote-com-shared/components/HeaderNavigation/MenuItem';
import {
  NavigationPrimary,
  NavigationSecondary as NavigationSecondaryComponent,
} from 'remote-com-shared/components/HeaderNavigation/styles/Navigation';
import { HubspotFormModalButton } from 'remote-com-shared/components/HubspotForm';
import styled, { css } from 'styled-components';

import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';

const ReferralButton = styled(ButtonOutline)`
  && {
    border-color: rgba(98, 77, 227, 0.45);
    box-shadow: none;
  }
`;

const NavigationSecondary = styled(NavigationSecondaryComponent)`
  ${tabletBreakpoint(css`
    margin-top: 50px;
  `)}
`;

export function autoApplyPromocode(promocode) {
  return promocode
    ? `${process.env.NEXT_PUBLIC_EMPLOY_BASE_URL}/sign-up?promoCode=${promocode}`
    : `${process.env.NEXT_PUBLIC_EMPLOY_BASE_URL}/sign-up`;
}

export function NavigationMenuPrimary() {
  return (
    <>
      <MenuEntry>
        <a href="#pricing" locale={false}>
          <MenuItem as="a">Pricing</MenuItem>
        </a>
      </MenuEntry>

      <MenuEntry>
        <a href="#testimonials" locale={false}>
          <MenuItem as="a">What they say</MenuItem>
        </a>
      </MenuEntry>
    </>
  );
}

export const NavigationMenu = ({
  showReferralFormButton,
  hubspotFormData,
  headerNavigationSitewide,
}) => (
  <>
    <NavigationPrimary>
      <NavigationMenuPrimary entries={headerNavigationSitewide?.navigationPrimary} />
    </NavigationPrimary>

    <NavigationSecondary>
      {showReferralFormButton && (
        <HubspotFormModalButton
          bodyStyle={{ width: '100%', maxWidth: '800px' }}
          {...hubspotFormData}
          button={{ as: ReferralButton }}
        >
          Submit a referral
        </HubspotFormModalButton>
      )}
    </NavigationSecondary>
  </>
);
